import { NextApiRequest } from 'next';
import { isAuthorizedSession, sessionFromDto } from '@nx-frontend/shared/types';
import { getSession } from './services';

interface ValidateSessionParams {
  req: NextApiRequest;
  userServiceUrl: string;
}

export async function validateSession(params: ValidateSessionParams) {
  const { req, userServiceUrl } = params;

  const { eversessionid: sessionId } = req.cookies;

  if (!sessionId) {
    return { session: null, error: 'Unauthorized' };
  }

  try {
    const session = sessionFromDto(await getSession({ host: userServiceUrl, sessionId }));

    if (!isAuthorizedSession(session)) {
      return { session: null, error: 'Unauthorized' };
    }

    return { session, error: null };
  } catch (err) {
    return { session: null, error: 'Unauthorized' };
  }
}
